<header [class.border-bottom-0]="!!notificationBar()">

  <div class="container">

    <div class="row align-items-center">

      <div class="col-auto d-xl-none">

        <button (click)="onMenuToggleClick()" class="menu-toggle btn btn-icon" i18n-title title="Меню">
          <mat-icon class="icon" svgIcon="sax:linear-menu"></mat-icon>
        </button>

      </div>

      <div class="logo-col col-auto">

        <a class="logo d-inline-block" routerLink="/">
          <img alt="Логотип EVLAND" class="logo-image d-none d-sm-block" height="38" i18n-alt
               ngSrc="/assets/images/logo-with-label.svg" width="141" />
          <img alt="Логотип EVLAND" class="logo-image d-sm-none" height="39" i18n-alt
               ngSrc="/assets/images/logo-simple.svg" width="40" />
        </a>

      </div>

      <div class="col-auto d-none d-xl-inline-flex" itemscope itemtype="http://schema.org/SiteNavigationElement">

        <ul class="nav" itemprop="about" itemscope itemtype="http://schema.org/ItemList">

          @for (navLink of navLinks; track navLink.label; let index = $index) {

            @if (navLink.children?.length) {

              <li (openChange)="onDropdownOpenChange(index, $event)" class="nav-item" ngbDropdown display="dynamic"
                  placement="bottom-start" itemprop="itemListElement" itemscope=""
                  itemtype="http://schema.org/ItemList">

                <a [class.disabled]="navLink.disabled" class="nav-link d-flex flex-row align-items-center"
                   ngbDropdownToggle [id]="'navbarDropdown' + index" role="button">

                  <span>{{ navLink.label }}</span>

                  @if (navLink.children?.length) {
                    <mat-icon class="arrow-icon ms-1"
                              [svgIcon]="dropdownState()[index] ? 'custom:chevron-up' : 'custom:chevron-down'"></mat-icon>
                  }

                  <meta [content]="navLink.label" itemprop="name">
                </a>

                <div ngbDropdownMenu dropdownClass="dropdown-menu" [aria-labelledby]="'navbarDropdown' + index"
                     class="dropdown-menu">

                  @for (childNavLink of navLink.children; track childNavLink.label) {
                    <a ngbDropdownItem [class.disabled]="childNavLink.disabled" [routerLink]="childNavLink.href"
                       [routerLinkActiveOptions]="{exact: childNavLink.href === '/'}"
                       routerLinkActive="active">
                      {{ childNavLink.label }}
                      @if (childNavLink.badge) {
                        <div class="ms-2 badge bg-primary">{{ childNavLink.badge }}</div>
                      }
                    </a>
                  }

                </div>

              </li>

            } @else {

              <li class="nav-item" itemprop="itemListElement" itemscope="" itemtype="http://schema.org/ItemList">

                <a [class.disabled]="navLink.disabled" [routerLink]="navLink.href"
                   [routerLinkActiveOptions]="{exact: navLink.href === '/'}" routerLinkActive="active"
                   class="nav-link d-flex flex-row align-items-center"
                   itemprop="url">

                  <span>{{ navLink.label }}</span>

                  <meta [content]="navLink.label" itemprop="name">
                </a>

              </li>

            }

          }

        </ul>

      </div>

      <div class="col d-flex flex-row justify-content-end align-items-center">

        <div (click)="openCallbackModal()"
             class="consultation-link d-none d-xxl-flex flex-row justify-content-center align-items-center">
          <mat-icon class="icon me-1" svgIcon="sax:bold-call-calling"></mat-icon>
          <span class="label" i18n>Консультація</span>
        </div>

        <evland-header-search-bar></evland-header-search-bar>

        @if (currentUser(); as currentUser) {
          <div class="ms-3 d-none d-xl-flex" placement="bottom-end" ngbDropdown>
            <button id="userMenuToggle" class="btn btn-icon btn-auth" ngbTooltip="Меню користувача" i18n-ngbTooltip
                    aria-label="Меню користувача" i18n-aria-label
                    role="button" ngbDropdownToggle>
              @if (currentUser.avatar) {
                <img [ngSrc]="currentUser.avatar.url" [alt]="currentUserFullName()"
                     width="40" height="40" class="avatar" priority="high" />
              } @else {
                <evland-avatar-placeholder [user]="currentUser"
                                           class="avatar-placeholder"></evland-avatar-placeholder>
              }
            </button>
            <div ngbDropdownMenu>
              @for (item of userMenuLinks; track item.label) {
                <a [routerLink]="item.href" routerLinkActive="active"
                   class="d-flex justify-content-start align-items-center" ngbDropdownItem>
                  <mat-icon [svgIcon]="item.icon" class="icon me-2"></mat-icon>
                  <span class="label">{{ item.label }}</span>
                </a>
              }
              <button (click)="onLogoutClick()" class="logout-button d-flex justify-content-start align-items-center"
                      ngbDropdownItem>
                <mat-icon svgIcon="sax:twotone-login-1" class="icon me-2"></mat-icon>
                <span class="label">Вийти</span>
              </button>
            </div>
          </div>
        } @else {
          <button (click)="openSignInModal()" class="btn btn-icon btn-auth ms-3 d-none d-xl-flex" ngbTooltip="Увійти"
                  aria-label="Увійти" i18n-aria-label role="button" i18n-ngbTooltip>
            <mat-icon class="auth-icon" svgIcon="sax:bulk-profile-circle"></mat-icon>
          </button>
        }

        <a class="btn btn-square btn-outline-secondary btn-comparison ms-3" i18n-ngbTooltip
           i18n-title ngbTooltip="Порівняння" routerLink="/comparison" title="Порівняння">

          <mat-icon class="icon" svgIcon="sax:linear-chart-1"></mat-icon>

          @if (modelsForComparison(); as modelsForComparison) {
            <span class="badge">{{ modelsForComparison }}</span>
          }

        </a>

      </div>

    </div>

  </div>

  @if (notificationBar(); as bar) {
    <div (click)="onNotificationBarClick()"
         [ngClass]="{ 'bg-danger text-white': bar.style === 'danger', 'bg-warning-subtle': bar.style === 'warning' }"
         class="notification-bar">{{bar.message}}</div>
  }

</header>

<ng-template #sidenavMenuContent let-modal>
  <evland-sidenav-menu (onClose)="modal.close($event)"></evland-sidenav-menu>
</ng-template>
